import { useMutation, useQuery } from '@tanstack/react-query';
import { suggestReply, fetchMacHistory, type MacSuggestRequest } from '@/api/macSuggest';

export function useMacSuggest(tenantId: string | undefined) {
  return useMutation({
    mutationFn: (req: MacSuggestRequest) => {
      if (!tenantId) throw new Error('tenantId required');
      return suggestReply(tenantId, req);
    },
  });
}

export function useMacHistory(tenantId: string | undefined, patientId: string | undefined, enabled = false) {
  return useQuery({
    queryKey: ['mac-history', tenantId, patientId],
    queryFn: () => {
      if (!tenantId || !patientId) throw new Error('tenantId and patientId required');
      return fetchMacHistory(tenantId, patientId);
    },
    enabled: enabled && !!tenantId && !!patientId,
    staleTime: 30_000,
  });
}
